import React, { useState } from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function MyNavbar() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      bg="dark"
      variant="dark"
      fixed="top"
      expand="lg"
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          Mangalagiri Pickles
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-end"
        >
          <Nav>
            <Nav.Link as={Link} to="/home">Home</Nav.Link>

            <NavDropdown title="Pickles" id="pickles-dropdown">
              <NavDropdown.Item
                as={Link}
                to="/vegetarian"
                onClick={() => setExpanded(false)}
              >
                Vegetarian
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/powders"
                onClick={() => setExpanded(false)}
              >
                Chilli Powders
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/non-veg"
                onClick={() => setExpanded(false)}
              >
                Non-Veg
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/about">About Us</Nav.Link>
            <Nav.Link as={Link} to="/contact">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MyNavbar;
